import { render, staticRenderFns } from "./PageLanguage.vue?vue&type=template&id=ecac9fa2&"
import script from "./PageLanguage.vue?vue&type=script&lang=js&"
export * from "./PageLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports